import CancelIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ExpandIcon from "@mui/icons-material/ExpandMoreRounded";
import SkippedIcon from "@mui/icons-material/RemoveCircleRounded";
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from "@mui/material";
import type { WorkflowValidationResult, WorkflowValidationVerdict } from "../../../../../api/types/workflowTypes";

const Summary = ({ verdict }: { verdict: WorkflowValidationVerdict }) => {
  switch (verdict) {
    case "ValidatedSuccessfully":
      return (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <CheckCircleIcon color="success" />
          <Typography variant="subtitle2" sx={{ color: "success.main" }}>
            Validated Successfully
          </Typography>
        </Stack>
      );
    case "ValidationFailed":
      return (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <CancelIcon color="error" />
          <Typography variant="subtitle2" sx={{ color: "error.main" }}>
            Validation Failed
          </Typography>
        </Stack>
      );
    case "ValidationSkipped":
      return (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <SkippedIcon color="secondary" />
          <Typography variant="subtitle2">Validation Skipped</Typography>
        </Stack>
      );
    default:
      return <Typography variant="subtitle2">Validation Result</Typography>;
  }
};

interface Props {
  validationResult: WorkflowValidationResult;
}

const WorkflowActivityValidationResults = ({ validationResult }: Props) => {
  return (
    <Accordion variant="outlined" disableGutters sx={{ mt: 2 }}>
      <AccordionSummary expandIcon={<ExpandIcon />}>
        <Summary verdict={validationResult.verdict} />
      </AccordionSummary>
      <AccordionDetails
        sx={{
          px: 2,
          py: 1.5,
          bgcolor: (t) => t.palette.background.grey,
          borderTop: (t) => `1px solid ${t.palette.divider}`,
        }}
      >
        <Typography>{validationResult.justification}</Typography>
      </AccordionDetails>
    </Accordion>
  );
};

export default WorkflowActivityValidationResults;
